import axios from 'axios'
import { useAProgressBar } from '../components/ui'

const progress = useAProgressBar()
const BASE_URL = ''
const API_URL = '/'

const instance = axios.create({
    baseURL: API_URL,
})

const useApi = async (url, config) => {
    try {
        const data = await instance.request({url: url, ...config})
        return data
    } catch (error) {
        return [error]
    }
}

const send = async (url = '', config = {},  data = {}) => {
    if(config.method.toUpperCase() === 'GET') {
        config.params = data
    } else if(config.method.toUpperCase() === 'POST') {
        config.data = data
    }
    const response = await useApi(url, config)
    return response.data
}

const sendRegisterNPO = async (data) => {
    const response = await useApi(`/`, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data,
        method: 'POST',
    })

    return response.data
}

const volonterProjectsLoadMore = async (params) => {
    progress.show()
    const response = await useApi('/local/templates/main/fakeapi/volonter-projects.json', {
        method: 'GET',
        params: params,
    })

    setTimeout(() => {
        progress.hide()
    }, 300);

    return response.data
}

const volonterReviewsLoadMore = async (params) => {
    progress.show()
    const response = await useApi('/local/templates/main/fakeapi/volonter-reviews.json', {
        method: 'GET',
        params: params,
    })

    setTimeout(() => {
        progress.hide()
    }, 300);

    return response.data
}

const saveAccountNPO = async (data) => {
    progress.show()
    const response = await useApi(`/`, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data,
        method: 'POST',
    })

    setTimeout(() => {
        progress.hide()
    }, 300);

    return response.data
}

export {
    API_URL,
    useApi,
    instance,
    send,
    sendRegisterNPO,
    volonterProjectsLoadMore,
    volonterReviewsLoadMore,
    saveAccountNPO,
}